import { get, post, put, del } from '../utils/fetch';

const FormUrlencoded = {
    'Content-Type': 'application/x-www-form-urlencoded',
};
const FormDate = {
    'Content-Type': 'application/form-data',
};
// 获取学校列表信息
export const querySchoolList = p => get('/prm/api/v1/dict/dim/school/name', p, { visitor: true });

// 获取学院列表信息
export const queryCollegeList = p => get('/prm/api/v1/dict/dim/school/college/name', p, { visitor: true });

// 获取专业列表信息
export const queryMajorList = p => get('/prm/api/v1/dict/dim/school/college/major/name', p, { visitor: true });

// 获取职业状态列表
export const queryProfessionalStatuses = () => get('/solon/api/v1/dictionary/careerStatus/list', {}, { visitor: true });

// 获取证件类型列表
export const queryCertificateTypes = () => get('/prm/api/v2/dict/basic', { typeId: 10026 }, { visitor: true });

// 获取学历列表
export const queryEducationList = () => get('/prm/api/v2/dict/basic', { typeId: 10025 }, { visitor: true });

// 获取省市地区列表
// export const queryAreasList = (p) =>
//     get(`/prm/api/v1/regions/sub/get`, p, { visitor: true });

// 获取省市地区列表
export const queryAreasList = p => post(`/prm/api/v1/regions/sub/getGlobalAreaByParentGuid`, p, { visitor: true });

// 学科门类条件查询
export const getByLevelAndCode = (p) => get("/luffy/internal/api/v1/cdp/getByLevelAndCode", p, { visitor: true })